var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('BaseNavigation',{attrs:{"active-navi-index":_vm.activeNaviIndex}}),_vm._v(" "),_c('div',{class:['contents', { scrolled: _vm.scrolled }]},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }